import { useEffect, useRef } from 'react';

export const usePrevious = <Value>(value: Value): Value | undefined => {
  const previous = useRef<Value | undefined>(undefined);

  useEffect(() => {
    previous.current = value;
  });

  return previous.current;
};
